module.exports = __webpack_public_path__ + "static/media/SubmitBrand.ae884ecd.svg";